import type { AIModelChoices } from 'api';

import { isLooseAiModel, isOtherAiModel } from '../../../evidence';
import { helpGuides } from '../../data';

export const getGuideForModel = (aiModel: AIModelChoices) => {
  if (isLooseAiModel(aiModel)) {
    return helpGuides[0];
  }

  if (aiModel === 'alu') {
    return helpGuides[1];
  }

  if (aiModel === 'hdpe') {
    return helpGuides[1];
  }

  if (aiModel === 'briquette') {
    return helpGuides[2];
  }

  if (isOtherAiModel(aiModel)) {
    return helpGuides[1];
  }

  return undefined;
};
